import styled from "styled-components";
import { OrdersGridContainer, SPLIT_MEDIA } from "../../../Common/Orders/styles";

export const SellersGridContainer = styled(OrdersGridContainer)`
  --o360-source-masuno: #6366f1;
  --o360-source-bees: #facc15;
  --o360-source-minegocio: #f97316;
  --o360-source-axtelesale: #3c9a88;
  --o360-source-axum: #355cdf;
  --o360-source-other: var(--ax-gray-400);

  .dark-mode & {
    --o360-source-masuno: #818cf8;
    --o360-source-bees: #fde047;
    --o360-source-minegocio: #fb923c;
    --o360-source-axtelesale: #5fb8a6;
    --o360-source-axum: #6f8ff0;
    --o360-source-other: var(--ax-gray-500);
  }

  && .o360-band-people {
    min-width: 0;
    overflow: hidden;
    color: var(--ax-text-muted);
    font-size: var(--ax-font-size-sm);
    text-overflow: ellipsis;
  }

  && .o360-sources {
    display: inline-flex;
    flex-direction: column;
    gap: var(--ax-space-1);
    /* 200px a 1280 y 400px a 1920: lo que deja libre la franja del vendedor sin cortar los nombres. */
    width: clamp(176px, 31.25vw - 200px, 480px);
    max-width: 100%;
    margin-left: var(--ax-space-4);
    text-align: left;
  }

  @media ${SPLIT_MEDIA} {
    && .ax-table-node-meta {
      flex: 1 0 100%;
    }

    && .o360-band-people + .ax-table-node-meta {
      margin-top: var(--ax-space-1);
    }

    && .o360-last-order {
      margin-right: auto;
    }

    && .o360-sources {
      order: 1;
      flex: 1 0 100%;
      width: auto;
      margin-left: 0;
    }
  }

  && .o360-sources-bar {
    --ax-progress-height: 6px;
  }

  && .o360-sources-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0 var(--ax-space-2);
    color: var(--ax-text-muted);
    font-size: var(--ax-font-size-xs);
    line-height: normal;
  }

  && .o360-sources-item {
    display: inline-flex;
    align-items: center;
    gap: var(--ax-space-1);
  }

  && .o360-sources-dot {
    width: 6px;
    height: 6px;
    border-radius: var(--ax-radius-round);
  }

  && .o360-source-masuno { background-color: var(--o360-source-masuno); }
  && .o360-source-bees { background-color: var(--o360-source-bees); }
  && .o360-source-minegocio { background-color: var(--o360-source-minegocio); }
  && .o360-source-axtelesale { background-color: var(--o360-source-axtelesale); }
  && .o360-source-axum { background-color: var(--o360-source-axum); }
  && .o360-source-other { background-color: var(--o360-source-other); }
`;
